import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {ApiResponse} from '@core/models/api-response.model';
import {ApplicationApi, ApplicationSession, ApplicationSessionUser} from '@core/models/application-session.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LOG_STYLRD} from './sa-logging.service';
import {Observable} from 'rxjs/Observable';
import {OnDestroy} from '@angular/core';
import {ApplicationSessionService} from './application-session.service';
import {AuthService} from './auth.service';
import {Subscription} from 'rxjs/Subscription';

export abstract class ServiceSupportService implements OnDestroy {

  public static HTTP_HEADERS = new HttpHeaders()
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json');


  protected api$$: Subscription;
  protected api$: Observable<ApplicationApi>;
  protected api: ApplicationApi;
  protected application$$: Subscription;
  protected application$: Observable<ApplicationSession>;
  protected application: ApplicationSession;
  protected user$$: Subscription;
  protected user$: Observable<ApplicationSessionUser>;
  protected user: ApplicationSessionUser;


  protected RETRY_COUNT = 1;
  protected alive: boolean;
  protected url_: string;

  public static doReject(response: ApiResponse) {
    return Promise.reject(response);
  }

  constructor(protected sessionService: ApplicationSessionService,
              protected http: HttpClient) {
    this.alive = true;

    // --->
    this.api$ = this.sessionService.observe('session.api');
    this.api$$ = this.api$
      .takeWhile(() => this.alive)
      .subscribe((api => this.api = api));

    // --->
    this.application$ = this.sessionService.observe('session');
    this.application$$ = this.application$
      .takeWhile(() => this.alive)
      .subscribe((application => this.application = application));

    // --->
    this.user$ = this.sessionService.observe('session.user');
    this.user$$ = this.user$
      .takeWhile(() => this.alive)
      .subscribe(user => this.user = user);

    // --->
    this.url_ = this.api.host + this.api.base; // + this.api.endpoints...;
  }

  ngOnDestroy(): void {
    this.alive = false;
    if (this.api$$ && !this.api$$.closed) {
      this.api$$.unsubscribe();
    }
    if (this.application$$ && !this.application$$.closed) {
      this.application$$.unsubscribe();
    }
    if (this.user$$ && !this.user$$.closed) {
      this.user$$.unsubscribe();
    }
  }

  protected _get<T>(url: string, headers: HttpHeaders): Observable<T> {
    return this.http.get<T>(url, {headers})
      .retry(this.RETRY_COUNT)
      .catch(ServiceSupportService.doReject);
  }

  protected _post<T>(url: string, headers: HttpHeaders, payload?: any): Observable<T> {
    return this.http.post<T>(url, payload, {headers})
      .retry(this.RETRY_COUNT)
      .catch(ServiceSupportService.doReject);
  }

  protected _put<T>(url: string, headers: HttpHeaders, payload?: any): Observable<T> {
    return this.http.put<T>(url, payload, {headers})
      .retry(this.RETRY_COUNT)
      .catch(ServiceSupportService.doReject);
  }

  protected _remove(url: string, headers: HttpHeaders): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(url, {headers})
      .retry(this.RETRY_COUNT)
      .catch(ServiceSupportService.doReject);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/service-support.service.ts